import { render, staticRenderFns } from "./CodigoRapipago.vue?vue&type=template&id=1a080521"
import script from "./CodigoRapipago.vue?vue&type=script&lang=js"
export * from "./CodigoRapipago.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports